import Vue from "vue";

import VueSanitize from "vue-sanitize";

let defaults = VueSanitize.defaults;

defaults.allowedTags = [...defaults.allowedTags, 'style']
defaults.allowedTags = [...defaults.allowedTags, 'img']
defaults.allowedTags = [...defaults.allowedTags, 'caption']
defaults.allowedTags = [...defaults.allowedTags, 'br']
defaults.allowedTags = [...defaults.allowedTags, 'map']
defaults.allowedTags = [...defaults.allowedTags, 'area']
defaults.allowedTags = [...defaults.allowedTags, 'iframe']
defaults.allowedTags = [...defaults.allowedTags, 'noscript']
defaults.allowedTags = [...defaults.allowedTags, 'font']
defaults.allowedTags = [...defaults.allowedTags, 'svg']
defaults.allowedTags = [...defaults.allowedTags, 'g']
defaults.allowedTags = [...defaults.allowedTags, 'path']
defaults.allowedTags = [...defaults.allowedTags, 'defs']
defaults.allowedTags = [...defaults.allowedTags, 'clipPath']
defaults.allowedTags = [...defaults.allowedTags, 'rect']

const aTageAllowAttr = [...defaults.allowedAttributes.a]

for(const index in defaults.allowedTags) {
  const tagNm = defaults.allowedTags[index];
  const tagAttr = defaults.allowedAttributes[tagNm]
  if(tagAttr != null){
    if(tagNm == 'a') {
      defaults.allowedAttributes[tagNm] = [...defaults.allowedAttributes[tagNm], 'class','style', 'rel', 'href','width','summary','onclick','id','tabindex','onkeydown','title']
    }else if(tagNm == 'img'){
      defaults.allowedAttributes[tagNm] = [...defaults.allowedAttributes[tagNm], 'class','style','width','summary', 'name','id','usemap']
    }else{
      defaults.allowedAttributes[tagNm] = [...defaults.allowedAttributes[tagNm], 'class','style','width','summary', 'name','id', 'title', 'caption']
    }
  }else{
    if(tagNm == 'th') {
      defaults.allowedAttributes[tagNm] = ['class','style', 'colspan', 'rowspan','width','summary','id', 'scope']
    }else if (tagNm == 'td') {
      defaults.allowedAttributes[tagNm] = ['class','style', 'colspan', 'rowspan','width','summary','id', 'tabindex']
    }else if(tagNm == 'area'){
      defaults.allowedAttributes[tagNm] = ['shape','coords', 'class','data-idx','data-site','alt','id','tabindex','onkeydown','href']
    }else if(tagNm == 'iframe') {
      defaults.allowedAttributes[tagNm] = ['width', 'height', 'src', 'title', 'frameborder', 'allow', 'allowfullscreen']
    }else if(tagNm == 'col') {
      defaults.allowedAttributes[tagNm] = ['class','style', 'colspan', 'width','id', 'span']
    }else if(tagNm == 'font') {
      defaults.allowedAttributes[tagNm] = ['color']
    }else if(tagNm == 'li'){
      defaults.allowedAttributes[tagNm] = ['class','style', 'rel','width','onclick','id']
    }else if(tagNm == 'g'){
      defaults.allowedAttributes[tagNm] = ['clip-path']
    }else if(tagNm == 'path'){
      defaults.allowedAttributes[tagNm] = ['d', 'fill', 'stroke', 'stroke-width', 'stroke-linecap', 'stroke-linejoin']
    }else if(tagNm == 'svg'){
      defaults.allowedAttributes[tagNm] = ['id', 'width', 'height', 'fill', 'xmlns']
    }else if(tagNm == 'clipPath'){
      defaults.allowedAttributes[tagNm] = ['id']
    }else if(tagNm == 'rect'){
      defaults.allowedAttributes[tagNm] = ['width', 'height', 'fill']
    }else{
      defaults.allowedAttributes[tagNm] = ['class','style','width','summary','name','id', 'title', 'caption']
    }
  }
}

export const boardDefaults = JSON.parse(JSON.stringify(defaults))
boardDefaults.allowedAttributes.a = [...aTageAllowAttr, 'class','style', 'rel', 'href','width','summary','id','title','tabindex']
// 이미지 tag: src=data:image 형식 때문에 추가
boardDefaults.allowedSchemesByTag.img = ['data', 'https', 'http']

defaults.allowVulnerableTags=true

Vue.use(VueSanitize,defaults);